import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { REPORT_CARD_AUDIENCE } from '../../../tokens/report-card-audience.token';
import {
	cardQueryStatusCopy,
	cardQueryStatusEmptyIcon,
	type CardQueryStatusKind,
	type CardQueryStatusNoun,
} from './card-query-status.util';

@Component({
	selector: 'jepto-card-query-status',
	imports: [MatIconModule],
	templateUrl: './jepto-card-query-status.component.html',
	styleUrl: './jepto-card-query-status.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	host: { class: 'jepto-card-query-status' },
})
export class JeptoCardQueryStatusComponent {
	readonly testId = input<string | undefined>();
	readonly kind = input.required<CardQueryStatusKind>();
	readonly noun = input<CardQueryStatusNoun>('chart');
	readonly chartType = input<string | undefined>();

	readonly refresh = output<void>();

	private readonly audience = inject(REPORT_CARD_AUDIENCE);

	readonly copy = computed(() =>
		cardQueryStatusCopy(this.audience, this.kind(), this.noun())
	);

	readonly icon = computed(() =>
		this.kind() === 'error'
			? 'error_outline'
			: cardQueryStatusEmptyIcon(this.chartType(), this.noun())
	);

	onRefresh(event: Event): void {
		event.stopPropagation();
		this.refresh.emit();
	}
}
